import React from 'react';

import { FormGroup, makeStyles, TextField } from '@material-ui/core';
import { TextFieldProps } from '@material-ui/core/TextField';

import * as Elevated from '@pitaman71/omniglot-introspect';
import { Annotations, Clients, Streams } from '@pitaman71/omniglot-live-data';
import { Domains } from '@pitaman71/omniglot-live-domains';
import { Propose } from '..';

const __moduleName__ = 'omniglot-live-react/MaterialUi';

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      minWidth: 0
    },
    textField: {
      marginRight: theme.spacing(1),
      width: '25ch',
    },
  }));
    
export function Number(props: Partial<Annotations.Annotation<JSX.Element>> & {
    domain?: Elevated.Domain<number>,
    value?: number,
    client?: Clients.ScalarClient<number>,
    inputProps?: TextFieldProps
}): JSX.Element {
    const elementRef = React.useRef<HTMLDivElement>(null);
    const [ error, setError ] = React.useState<string|undefined>(undefined);

    return (
        <FormGroup style={{ display: "block" }}>
            <TextField ref={elementRef} label={props.label} style={{marginTop: '0.5em'}} type="number"
                { ...props.inputProps }
                value={props.value === undefined ? "" : props.value }
                helperText={error}
                onChange={ ((event:any) => {
                    if(!props.client) {
                        // skip
                    } else if(event.target.value === null || event.target.value === undefined || event.target.value === "") {
                        props.client.clear()
                    } else if(props.domain) {
                        try {
                            const parsed = props.domain.asString()?.from(event.target.value);
                            parsed && props.client.assign(parsed);
                        } catch(err:any) {
                            setError(err.toString());
                        }
                    }
                }) }
            />
        </FormGroup>
    );
}

export function String(props: Partial<Annotations.Annotation<JSX.Element>> & {
    key: string,
    domain?: Elevated.Domain<string>,
    value?: string,
    client?: Clients.ScalarClient<string>,
    inputProps?: TextFieldProps
}): JSX.Element {
    const elementRef = React.useRef<HTMLDivElement>(null);
    const [ error, setError ] = React.useState<string|undefined>(undefined);
    return (
        <FormGroup style={{ display: "block" }}>
            <TextField ref={elementRef} key={props.key} label={props.label} style={{marginTop: '0.5em'}} type="text"
                { ...props.inputProps }
                value={props.value === undefined ? "" : props.value }
                helperText={error}
                onChange={ ((event:any) => {
                    if(props.client === undefined) {
                        // skip
                    } else if(event.target.value === null || event.target.value === undefined || event.target.value === "") {
                        props.client.clear()
                    } else if(props.domain) {
                        try {
                            const parsed = props.domain.asString()?.from(event.target.value);
                            parsed && props.client.assign(parsed);
                        } catch(err:any) {
                            setError(err.toString());
                        }
                    }
                }) }
            />
        </FormGroup>
    );
}

export function Date(props: Partial<Annotations.Annotation<JSX.Element>> & {
    domain?: Elevated.Domain<Partial<Domains.Temporal._Date>>,
    value?: Partial<Domains.Temporal._Date>,
    client?: Clients.ScalarClient<Partial<Domains.Temporal._Date>>,
    inputProps?: TextFieldProps
}): JSX.Element {
    const elementRef = React.useRef<HTMLDivElement>(null);
    const [ error, setError ] = React.useState<string|undefined>(undefined);

    return (
        <FormGroup style={{ display: "block" }}>
            <TextField ref={elementRef} type="text" placeholder='mm/dd/yyyy'
                value={props.value !== undefined ? props.domain?.asString()?.to(props.value) : props.value || "" }
                onChange={ ((event:any) => {
                    if(props.client === undefined) {
                        // skip
                    } else if(event.target.value === null || event.target.value === undefined || event.target.value === "") {
                        props.client.clear()
                    } else if(props.domain) {
                        try {
                            const parsed = props.domain.asString()?.from(event.target.value);
                            parsed && props.client.assign(parsed);
                        } catch(err:any) {
                            setError(err.toString());
                        }
                    }
                }) }
            />
        </FormGroup>
    );
}

export function Password(props: Partial<Annotations.Annotation<JSX.Element>> & {
    domain?: Elevated.Domain<string>,
    value?: string,
    client?: Clients.ScalarClient<string>,
    inputProps?: TextFieldProps
}): JSX.Element {
    const elementRef = React.useRef<HTMLDivElement>(null);
    const [ error, setError ] = React.useState<string|undefined>(undefined);

    return (
        <FormGroup style={{ display: "block" }}>
            <TextField ref={elementRef} label={props.label} style={{marginTop: '0.5em'}} type="password"
                { ...props.inputProps }
                value={props.value === undefined ? "" : props.value }
                helperText={error}
                onChange={ ((event:any) => {
                    if(props.client === undefined) {
                        // skip
                    } else if(event.target.value === null || event.target.value === undefined || event.target.value === "") {
                        props.client.clear()
                    } else if(props.domain) {
                        try {
                            const parsed = props.domain.asString()?.from(event.target.value);
                            parsed && props.client.assign(parsed);
                        } catch(err:any) {
                            setError(err.toString());
                        }
                    }
                }) }
            />
        </FormGroup>
    );
}

export function Email(props: Partial<Annotations.Annotation<JSX.Element>> & {
    domain?: Elevated.Domain<string>,
    value?: string,
    client?: Clients.ScalarClient<string>,
    inputProps?: TextFieldProps
}): JSX.Element {
    const elementRef = React.useRef<HTMLDivElement>(null);
    const [ error, setError ] = React.useState<string|undefined>(undefined);
    return (
        <FormGroup style={{ display: "block" }}>
            <TextField ref={elementRef} label={props.label} style={{marginTop: '0.5em'}} type="email"
                { ...props.inputProps }
                value={props.value === undefined ? "" : props.value }
                helperText={error}
                onChange={ ((event:any) => {
                    if(props.client === undefined) {
                        // skip
                    } else if(event.target.value === null || event.target.value === undefined || event.target.value === "") {
                        props.client.clear()
                    } else if(props.domain) {
                        try {
                            const parsed = props.domain.asString()?.from(event.target.value);
                            parsed && props.client.assign(parsed);
                        } catch(err:any) {
                            setError(err.toString());
                        }
                    }
                }) }
            />
        </FormGroup>
    );
}

export function Phone(props: Partial<Annotations.Annotation<JSX.Element>> & {
    domain?: Elevated.Domain<string>,
    value?: string,
    client?: Clients.ScalarClient<string>,
    inputProps?: TextFieldProps
}): JSX.Element {
    const elementRef = React.useRef<HTMLDivElement>(null);
    const [ error, setError ] = React.useState<string|undefined>(undefined);

    return (
        <FormGroup style={{ display: "block" }}>
            <TextField ref={elementRef} label={props.label} style={{marginTop: '0.5em'}} type="tel"
                { ...props.inputProps }
                value={props.value === undefined ? "" : props.value }
                helperText={error}
                onChange={ ((event:any) => {
                    if(props.client === undefined) {
                        // skip
                    } else if(event.target.value === null || event.target.value === undefined || event.target.value === "") {
                        props.client.clear()
                    } else if(props.domain) {
                        try {
                            const parsed = props.domain.asString()?.from(event.target.value);
                            parsed && props.client.assign(parsed);
                        } catch(err:any) {
                            setError(err.toString());
                        }
                    }
                }) }
            />
        </FormGroup>
    );
}        
        
